import { injectable } from 'inversify';
import { DiContainer } from '@@/di/di-container';
import { ClientStorageService } from '@@/common/services/client-storage.service';
import { IAnalyticsMixingService } from '@@/mixing/services/IAnalyticsMixingService.interface';
import { AnalyticsMixingData } from '@@/mixing/ts/analytic.types';
import { get, post, put } from '@api/api-client';
import { BestPricesResponseItem } from '../ts/buyers-prices.types';

@injectable()
export class AnalyticsMixingService implements IAnalyticsMixingService {
  constructor(
    private readonly clientStorageService = DiContainer.get(ClientStorageService),
  ) {}

  getData(period?: number): Promise<AnalyticsMixingData> {
    const requestBody = period ? { period } : {};

    return get<AnalyticsMixingData>(
      `${PUBLIC_API_URL}/analytical_mixing`,
      requestBody,
      document.cookie,
    );
  }

  getWarehousesForMixing(): Promise<any> {
    return post(`${PUBLIC_API_URL}/mixingrecipe`, {}, document.cookie);
  }

  getBestMarketPrices(
    trade?: boolean,
    moistureChangesDensity?: boolean,
  ): Promise<BestPricesResponseItem[]> {
    return get(
      `${PUBLIC_API_URL}/best_market_price`,
      trade ? { trade: true, moisture_changes_density: !!moistureChangesDensity } : {},
      document.cookie,
    );
  }
}
